
// import { useState, useEffect } from "react";
// import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";
// import { FaXTwitter } from "react-icons/fa6";

// export default function StickySocial() {
//   const [isVisible, setIsVisible] = useState(false);
//   const [hasInteracted, setHasInteracted] = useState(false);
//   const [timeoutId, setTimeoutId] = useState(null);

//   const socials = [
//     { 
//       icon: <FaFacebookF />, 
//       link: "#", 
//       bgColor: "bg-blue-600", 
//       hoverColor: "hover:bg-blue-700" 
//     },
//     { 
//       icon: <FaXTwitter />, 
//       link: "#", 
//       bgColor: "bg-black", 
//       hoverColor: "hover:bg-zinc-900" 
//     },
//     { 
//       icon: <FaLinkedinIn />, 
//       link: "#", 
//       bgColor: "bg-blue-700", 
//       hoverColor: "hover:bg-blue-800" 
//     },
//     { 
//       icon: <FaInstagram />, 
//       link: "#", 
//       bgColor: "bg-gradient-to-br from-pink-500 via-purple-500 to-orange-500", 
//       hoverColor: "hover:brightness-110" 
//     },
//     { 
//       icon: <FaYoutube />, 
//       link: "#", 
//       bgColor: "bg-red-600", 
//       hoverColor: "hover:bg-red-700" 
//     },
//   ];

//   const handleMouseMove = () => {
//     setIsVisible(true);
//     setHasInteracted(true);

//     if (timeoutId) clearTimeout(timeoutId);

//     const newTimeout = setTimeout(() => {
//       setIsVisible(false);
//     }, 3000);

//     setTimeoutId(newTimeout);
//   };

//   useEffect(() => {
//     window.addEventListener("mousemove", handleMouseMove);

//     return () => {
//       window.removeEventListener("mousemove", handleMouseMove);
//       if (timeoutId) clearTimeout(timeoutId);
//     };
//   }, [timeoutId]);

//   return (
//     <div
//       className={`fixed left-4 top-1/2 -translate-y-1/2 z-50 hidden md:flex flex-col gap-3 
//         transition-all duration-500 ease-in-out`}
//       style={{
//         opacity: isVisible ? 1 : 0,
//         transform: isVisible 
//           ? "translateX(0)" 
//           : "translateX(-40px)",
//       }}
//     >
//       {socials.map((s, i) => (
//         <a
//           key={i}
//           href={s.link}
//           target="_blank"
//           rel="noopener noreferrer"
//           className={`w-10 h-10 flex items-center justify-center rounded-full 
//             border border-white/70 shadow-lg text-white 
//             transition-all duration-300 hover:scale-110 ${s.bgColor} ${s.hoverColor}`}
//         >
//           {s.icon}
//         </a>
//       ))}
//     </div>
//   );
// }







// new new code 




import { useState, useEffect } from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

export default function StickySocial() {
  const [isVisible, setIsVisible] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);
  const [isMapSectionVisible, setIsMapSectionVisible] = useState(false);

  const socials = [
    { icon: <FaFacebookF />, link: "https://www.facebook.com/ASSOCHAM4Ind", bgColor: "bg-blue-600", hoverColor: "hover:bg-blue-700" },
    { icon: <FaXTwitter />, link: "https://x.com/ASSOCHAM4India", bgColor: "bg-black", hoverColor: "hover:bg-zinc-900" },
    { icon: <FaLinkedinIn />, link: "https://www.linkedin.com/company/assochamforindia/", bgColor: "bg-blue-700", hoverColor: "hover:bg-blue-800" },
    { icon: <FaInstagram />, link: "https://www.instagram.com/assocham/", bgColor: "bg-gradient-to-br from-pink-500 via-purple-500 to-orange-500", hoverColor: "hover:brightness-110" },
    { icon: <FaYoutube />, link: "https://www.youtube.com/channel/UCL3mhKqDyERa1dTEXL3uP_Q", bgColor: "bg-red-600", hoverColor: "hover:bg-red-700" },
  ];

  const handleMouseMove = () => {
    if (isMapSectionVisible) return;

    setIsVisible(true);

    if (timeoutId) clearTimeout(timeoutId);

    const newTimeout = setTimeout(() => {
      setIsVisible(false);
    }, 3000);

    setTimeoutId(newTimeout);
  };

  // Detect Map Location section using multiple selectors
  useEffect(() => {
    const mapSection = 
      document.getElementById("map-location") || 
      document.getElementById("contact") || 
      document.querySelector(".map-location") ||
      document.querySelector("footer");

    if (!mapSection) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsMapSectionVisible(entry.isIntersecting);
        if (entry.isIntersecting) {
          setIsVisible(false);
        }
      },
      { 
        threshold: 0.25   // Show hide when 25% of footer is visible
      }
    );

    observer.observe(mapSection);

    return () => observer.disconnect();
  }, []);

  // Mouse move listener
  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [timeoutId, isMapSectionVisible]);

  return (
    <div
      className={`fixed left-4 top-1/2 -translate-y-1/2 z-50 hidden md:flex flex-col gap-3 
        transition-all duration-500 ease-in-out`}
      style={{
        opacity: isVisible && !isMapSectionVisible ? 1 : 0,
        transform: isVisible && !isMapSectionVisible 
          ? "translateX(0)" 
          : "translateX(-40px)",
      }}
    >
      {socials.map((s, i) => (
        <a
          key={i}
          href={s.link}
          target="_blank"
          rel="noopener noreferrer"
          className={`w-10 h-10 flex items-center justify-center rounded-full 
            border border-white/70 shadow-lg text-white 
            transition-all duration-300 hover:scale-110 ${s.bgColor} ${s.hoverColor}`}
        >
          {s.icon}
        </a>
      ))}
    </div>
  );
}